import styled from 'styled-components';

const spacing = '0.5rem';

export default styled.div`
  display: grid;
  grid-template-columns: 16px 1fr auto;
  grid-template-areas: 'icon text date';
  grid-column-gap: ${spacing};
  font-size: 0.8rem;
  padding: ${spacing} ${spacing} 0;

  &:last-child {
    padding-bottom: ${spacing};
  }
`;
